var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "portal",
    { attrs: { to: "dash" } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.active
          ? _c(
              "div",
              {
                staticClass: "drop-file-overlay",
                on: {
                  dragover: function ($event) {
                    $event.preventDefault()
                  },
                  dragleave: function ($event) {
                    $event.preventDefault()
                    return _vm.handleDragLeave.apply(null, arguments)
                  },
                  drop: function ($event) {
                    $event.preventDefault()
                    return _vm.onDrop.apply(null, arguments)
                  },
                  mousemove: _vm.handleDragLeave,
                },
              },
              [
                _c("div", { staticClass: "drop-card" }, [
                  _c("div", { staticClass: "icon" }, [_vm._v("📥")]),
                  _c("h3", [_vm._v("Déposez vos fichiers")]),
                  _c("p", [_vm._v("Relâchez pour lancer l'upload")]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }